import { securedAxios } from "../lib/axios";
import urljson from "../lib/urljson";

export default {
  namespaced: true,
  state: {
    contasReceber: []
  },
  mutations: {
    carregar(state, contasReceber) {
      state.contasReceber = [];
      state.contasReceber = contasReceber;
    }
  },
  actions: {
    async listar({ commit }, opcoes) {
      try {
        const response = await securedAxios.get(
          `/contareceber?opcoes=${urljson(opcoes)}`
        );
        //console.log(response.data);
        commit("carregar", response.data);
        return Promise.resolve(response);
      } catch (e) {
        return Promise.reject(e);
      }
    },
    async retornaDados(context, opcoes) {
      try {
        const response = await securedAxios.get(
          `/contareceber?opcoes=${urljson(opcoes)}`
        );

        return Promise.resolve(response.data);
      } catch (e) {
        return Promise.reject(e);
      }
    },
    async gravar(context, contasReceberInfo) {
      try {
        let response;
        if (contasReceberInfo.id == "") {
          delete contasReceberInfo.id;
          response = await securedAxios.post(
            "/contareceber",
            contasReceberInfo
          );
        } else {
          var id = contasReceberInfo.id;
          delete contasReceberInfo.id;
          response = await securedAxios.put(
            "/contareceber/" + id,
            contasReceberInfo
          );
        }

        return Promise.resolve(response.data);
      } catch (err) {
        return Promise.reject(err);
      }
    },
    async gravarBoleto(context, boletoInfo) {
      try {
        let response;
        let id = boletoInfo.get("id");
        boletoInfo.delete("id");
        response = await securedAxios.post(
          "/contareceber/" + id + "/grava-boleto",
          boletoInfo
        );
        return Promise.resolve(response.data);
      } catch (err) {
        return Promise.reject(err);
      }
    },

    async deletar(context, id) {
      try {
        const response = securedAxios.delete("/contareceber/" + id);
        return Promise.resolve(response);
      } catch (err) {
        return Promise.reject(err);
      }
    },
    carregarContasReceber(context, id) {
      return securedAxios.get(`/contareceber/${id}`);
    },
    async deletarPorFatura(context, id_fatura) {
      try {
        const response = securedAxios.delete(`/origem/FAT/${id_fatura}`);
        return Promise.resolve(response);
      } catch (err) {
        return Promise.reject(err);
      }
    },
    async deletarPorNota(context, id_nfs) {
      try {
        const response = securedAxios.delete(`/origem/NFS/${id_nfs}`);
        return Promise.resolve(response);
      } catch (err) {
        return Promise.reject(err);
      }
    }
  }
};
